import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Loading from "../../loading/Loading";
import Apis from "../../Apis";
import { showAlert } from '../../ui/dialog';
import { FiHash, FiFileText, FiPackage, FiDollarSign, FiArchive, FiToggleRight, FiGrid } from 'react-icons/fi';
import FormWizard from '../../ui/FormWizard';
import { InputField, SelectField, FormRow } from '../../ui/InputField';

const CadastrarProduto = () => {
    const [codigo, setCodigo] = useState('');
    const [unidadeBd, setUnidadeBd] = useState([]);
    const [descricao, setDescricao] = useState('');
    const [idUnidade, setIdUnidade] = useState('');
    const [siglaUnidade, setSiglaUnidade] = useState('');
    const [preco, setPreco] = useState('');
    const [status, setStatus] = useState('');
    const [estoque, setEstoque] = useState('');
    const [tipo, setTipo] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const alertaErro = (texto) => showAlert({ title: "Atenção", text: texto, icon: "error", dangerMode: true });

    useEffect(() => {
        setLoading(true);
        fetch(Apis.urlListarUnidades, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify("")
        }).then(response => response.json()).then(result => {
            setUnidadeBd(result.registros);
            setLoading(false);
        });
    }, []);

    const handleSubmit = () => {
        if (codigo === '' || descricao === '' || idUnidade === '' || preco === '' || status === '' || estoque === '' || tipo === '') {
            alertaErro('Todos os campos devem ser preenchidos!');
            return;
        }
        setLoading(true);
        fetch(Apis.urlCadastrarProdutos, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({ "codigo": codigo, "descricao": descricao, "unidade": siglaUnidade, "unidade_id": idUnidade, "preco": preco, "status": status, "estoque": estoque, "tipo": tipo, "meu_id": "0" })
        }).then(response => response.json()).then(result => {
            if (result.retorno.sucesso) {
                navigate(`/alerta-sucesso/${result.retorno.mensagem}&listar-produtos`);
            } else {
                alertaErro(result.retorno.mensagem);
            }
            setLoading(false);
        });
    };

    if (idUnidade === "cadastrarUnidade") navigate(`/cadastrar-unidade/1`);
    if (loading) return <Loading />;

    return (
        <FormWizard
            title="Cadastro de Produto"
            icon={<FiPackage />}
            steps={['Dados do Produto', 'Preço & Estoque']}
            onSubmit={handleSubmit}
            submitLabel="Cadastrar"
        >
            {/* Passo 1 — Dados do Produto */}
            <>
                <FormRow>
                    <InputField label="Código" icon={<FiHash />} required
                        placeholder="Código do produto"
                        onChange={e => setCodigo(e.target.value)} value={codigo} />
                    {unidadeBd ? (
                        <SelectField label="Unidade" icon={<FiPackage />} required
                            value={idUnidade}
                            onChange={e => { setIdUnidade(e.target.value); setSiglaUnidade(e.target.options[e.target.selectedIndex].text); }}>
                            <option value="vazio">— selecione a unidade —</option>
                            {unidadeBd.map(u => (
                                <option value={u.id} key={u.id}>{u.sigla}</option>
                            ))}
                            <option value="cadastrarUnidade">Cadastrar unidade</option>
                        </SelectField>
                    ) : (
                        <Link to="/cadastrar-unidade/1">
                            <button type="button" style={{ width: '100%', height: 44, borderRadius: 4, background: 'linear-gradient(135deg, #3d7a9c, #1e3a4c)', color: '#fff', border: 'none', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>
                                Cadastrar Unidade
                            </button>
                        </Link>
                    )}
                </FormRow>
                <InputField label="Descrição" icon={<FiFileText />} required
                    placeholder="Descrição do produto"
                    onChange={e => setDescricao(e.target.value)} value={descricao} />
            </>

            {/* Passo 2 — Preço & Estoque */}
            <>
                <FormRow>
                    <InputField label="Preço" icon={<FiDollarSign />} required
                        type="number" placeholder="0,00"
                        onChange={e => setPreco(e.target.value)} value={preco} />
                    <InputField label="Quantidade em estoque" icon={<FiArchive />} required
                        placeholder="Quantidade"
                        onChange={e => setEstoque(e.target.value)} value={estoque} />
                </FormRow>
                <FormRow>
                    <SelectField label="Status" icon={<FiToggleRight />} required
                        onChange={e => setStatus(e.target.value)} value={status}>
                        <option value="vazio">— selecione o status —</option>
                        <option value="0">Ativo</option>
                        <option value="1">Inativo</option>
                    </SelectField>
                    <SelectField label="Tipo" icon={<FiGrid />} required
                        onChange={e => setTipo(e.target.value)} value={tipo}>
                    <option value="vazio">— selecione o tipo —</option>
                    <option value="0">Mercadoria para Revenda</option>
                    <option value="1">Matéria-Prima</option>
                    <option value="2">Embalagem</option>
                    <option value="3">Produto em Processo</option>
                    <option value="4">Produto Acabado</option>
                    <option value="5">Subproduto</option>
                    <option value="6">Produto Intermediário</option>
                    <option value="7">Material de Uso e Consumo</option>
                    <option value="8">Ativo Imobilizado</option>
                    <option value="9">Serviços</option>
                    <option value="10">Outros insumos</option>
                    <option value="99">Outras</option>
                    </SelectField>
                </FormRow>
            </>
        </FormWizard>
    );
};

export default CadastrarProduto;
